export const sections = [
  'base',
  'applications',
  'events',
  'news',
  'roster',
  'loot',
  'none',
] as const

type Section = typeof sections[number]
export default Section
